var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card-toolbar',{attrs:{"title":_vm.$tc('not_authorized')}}),_c('v-row',{staticClass:"pa-4"},[_c('h1',[_vm._v(_vm._s(_vm.$tc('not_authorized')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }